export default __webpack_public_path__ + "static/key_b.c2d063e9b1bba3b3ccc8b14890e01eb9.png";